// Permission checking utilities for page-level access control

// Map navigation items to their required permissions
export const PAGE_PERMISSIONS = {
  '/': 'Access Reports',
  '/payments': 'Access Payments',
  '/payments/riders': 'Access Rider Payments',
  '/payments/owners': 'Access Owner Payments', 
  '/temporary/payments': 'Access Temporary Users Management',
  '/payments/miscellaneous': 'Access Miscellaneous Payments',
  '/sessions': 'Access Sessions',
  '/attendance': 'Access Attendance',
  '/users': 'Access Personnel Management', // UsersHub - allow if user has any user-management permission
  '/personnel': 'Access Personnel Management',
  '/coaches': 'Access Coaches Management',
  '/riders': 'Access Riders Management',
  '/owners': 'Access Owners Management',
  '/temporary': 'Access Temporary Users Management',
  '/suppliers': 'Access Suppliers Management',
  '/inventory': 'Access Inventory Management',
  '/institutional/personnel': 'Access Institutional Personnel',
  '/institutional/other': 'Access Institutional Other',
  '/institutional/finance': 'Access Institutional Personnel',
  '/permissions': 'Manage Permissions',
  '/subscribers': 'Access Subscribers Management',
};

// Check if user has permission to access a specific page
export const hasPagePermission = (user, pathname) => {
  console.log(`hasPagePermission - Checking ${pathname} for user:`, user?.name, 'Role:', user?.role);
  
  // SuperAdmin and Admin have access to everything
  if (user?.role === 4 || user?.role === 'SuperAdmin' || user?.role === 3 || user?.role === 'Admin') {
    console.log('hasPagePermission - SuperAdmin or Admin access granted');
    return true;
  }

  // Get the required permission for this page
  const requiredPermission = PAGE_PERMISSIONS[pathname];
  console.log(`hasPagePermission - Required permission: ${requiredPermission}`);
  
  if (!requiredPermission) {
    // If no permission is defined for this page, deny access by default
    console.log('hasPagePermission - No permission defined for this page, access denied');
    return false;
  }

  // Check if user has the required permission
  if (!user?.permissions || !Array.isArray(user.permissions)) {
    console.log('hasPagePermission - No permissions array, access denied');
    return false;
  }

  console.log(`hasPagePermission - User permissions:`, user.permissions.map(p => p.name));
  
  const hasPermission = user.permissions.some(permission => 
    permission.name === requiredPermission && permission.isGranted
  );
  
  console.log(`hasPagePermission - Result: ${hasPermission}`);
  return hasPermission;
};

// Check if user has any of the specified permissions
export const hasAnyPermission = (user, permissionNames) => {
  if (!user?.permissions || !Array.isArray(user.permissions)) {
    return false;
  }

  return permissionNames.some(permissionName =>
    user.permissions.some(permission => 
      permission.name === permissionName && permission.isGranted
    )
  );
};

// Check if user has all of the specified permissions
export const hasAllPermissions = (user, permissionNames) => {
  if (!user?.permissions || !Array.isArray(user.permissions)) {
    return false;
  }

  return permissionNames.every(permissionName =>
    user.permissions.some(permission => 
      permission.name === permissionName && permission.isGranted
    )
  );
};

// Check if user has any permissions at all
export const hasAnyPermissions = (user) => {
  // SuperAdmin has all permissions
  if (user?.role === 4 || user?.role === 'SuperAdmin') {
    return true;
  }
  
  if (!user?.permissions || !Array.isArray(user.permissions)) {
    return false;
  }
  
  return user.permissions.some(permission => permission.isGranted);
};
